const DEFAULT_PAGE_NUMBER = 1;
const NONE = 'none';
const CROSS_ORIGIN_ANONYMOUS = 'anonymous';
const MAXIMUM_IMAGE_DISPLAY = 5;
const AVAILABLE = 'available';
const UNAVAILABLE = 'unavailable';
const ICON_PREFERENCE = 'preference';
const ICON_CHECK_CIRCLE_OUTLINE = 'checkCircleOutline';
const CHANNEL_EBEDS = 'ebeds';
const WELLTRAVEL = 'Welltravel';
const RESPONSIVE_SLIDER_CONFIG = Object.freeze([
  { breakPoint: 1376, cardsToShow: 6 },
  { breakPoint: 991, cardsToShow: 5 },
  { breakPoint: 768, cardsToShow: 4 },
]);

export {
  AVAILABLE,
  CHANNEL_EBEDS,
  WELLTRAVEL,
  UNAVAILABLE,
  DEFAULT_PAGE_NUMBER,
  NONE,
  CROSS_ORIGIN_ANONYMOUS,
  MAXIMUM_IMAGE_DISPLAY,
  RESPONSIVE_SLIDER_CONFIG,
  ICON_PREFERENCE,
  ICON_CHECK_CIRCLE_OUTLINE,
};
